import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import MessagePage from '../../views/MessagePage/';

class GreetingSMS extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			bdaywish : '',
			isUnicode : 0,
			mrgewish : '',
			isUnicode1 : 0,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
		
	}
	
  
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("smstempform").reset();
	}
	
	onChkChange(e){
		
		if(e.target.checked){
			
			this.state.isUnicode = 1;
		}
		else {
			
			this.state.isUnicode = 0;
		}
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		this.state.smscount = $("#smscount").val();
		this.state.smscount1 = $("#smscount1").val();
		$("#showLoader").show();
			PostData('message/addsmsgreet',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Greeting SMS Added Successfully!..',
						alertClass:'alert alert-success',
					});
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		// }
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdata();
	}
	
	/** get Greeting SMS **/
	getdata(){
		$("#showLoader").show();
		GetData('message/getgreetings').then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					bdaywish : res[0]['birthday_msg'],
					isUnicode : res[0]['birthday_unicode'],
					mrgewish : res[0]['marraige_msg'],
					isUnicode1 : res[0]['marraige_unicode']
				});
				
				if(res[0]['birthday_unicode'] == 1){
					
					$("#isUnicode").prop("checked", true);
				}
				else{
					
					$("#isUnicode").prop("checked", false);
				}
				if(res[0]['marraige_unicode'] == 1){
					
					$("#isUnicode1").attr("checked", "checked");
				}
			}
		});
	}
	
	
  render() {

	$('#bday').keyup(function(){
		
		var chars = this.value.length;
		if( $("#isUnicode").prop("checked") ){
			var messages = Math.ceil(chars / 70),
			remaining = messages * 70 - (chars % (messages * 70) || messages * 70);
		}
		else{
			var messages = Math.ceil(chars / 160),
			 remaining = messages * 160 - (chars % (messages * 160) || messages * 160);
		}

		$("#remaining").text(remaining+ ' characters remaining ');
		$("#messages").text(messages + ' message(s)');
		
	});
	
	$('#mrge').keyup(function(){
		
		var chars = this.value.length;
		if( $("#isUnicode1").prop("checked") ){
			var messages1 = Math.ceil(chars / 70),
			remaining1 = messages1 * 70 - (chars % (messages1 * 70) || messages1 * 70);	
		}
		else{
			var messages1 = Math.ceil(chars / 160),
			 remaining1 = messages1 * 160 - (chars % (messages1 * 160) || messages1 * 160);
		}

		$("#remaining1").text(remaining1+ ' characters remaining ');
		$("#messages1").text(messages1+ ' message(s)');
		
	});
	
    return (
		<div>
		  <MessagePage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="smstempform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<input type="hidden" id="smscount" />
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Greeting SMS Setup</strong>
						</CardHeader>
						<CardBody>
						  <Row>
						   <Col md="12">
							  <Card>
								<CardBody>
									<Row>
									  <Col md="3">
										<Label><b>Birthday Wishes</b></Label>
									  </Col>
									  <Col md="9">
										<FormGroup>
										  <Input type="textarea" name="bdaywish" id="bday" onChange={this.onChange} rows="5" placeholder="Type Message Here" value={this.state.bdaywish}/>
										  <span id="remaining">160 characters remaining </span>
										  <span id="messages">1 message(s)</span>
										</FormGroup>
										<FormGroup check inline>
											<Label className="form-check-label" check htmlFor="inline-checkbox1">Unicode Message</Label>&nbsp;&nbsp;&nbsp;
											<Input className="form-check-input" type="checkbox" id="isUnicode" onChange={this.onChkChange} name="isUnicode" />
										</FormGroup>
									  </Col>
									</Row>
								</CardBody>
							  </Card>
							</Col>
							
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Save Greetings</Button>
						</CardFooter>
					</Card>
				  </Col>
				  
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default GreetingSMS;


// WEBPACK FOOTER //
// ./src/message/GreetingSMS/GreetingSMS.js